import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type PassportUser = { userId: string; email: string };

type PassportState = {
  user: PassportUser | null;
  pendingStampToken: string | null;
  setUser: (user: PassportUser) => void;
  clear: () => void;
  setPendingStampToken: (token: string | null) => void;
};

export const usePassportStore = create<PassportState>()(
  persist(
    (set) => ({
      user: null,
      pendingStampToken: null,
      setUser: (user) => set({ user }),
      clear: () => set({ user: null, pendingStampToken: null }),
      setPendingStampToken: (token) => set({ pendingStampToken: token }),
    }),
    { name: 'passport-auth' },
  ),
);
